import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgImage(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M8 9.94775C9.10457 9.94775 10 9.05232 10 7.94775C10 6.84318 9.10457 5.94775 8 5.94775C6.89543 5.94775 6 6.84318 6 7.94775C6 9.05232 6.89543 9.94775 8 9.94775Z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM20 14.238L17.5369 11.2822C16.7549 10.3438 15.2518 10.3358 14.4633 11.2832L10.9347 15.5225L9.41366 14.0001C8.63303 13.22 7.36747 13.2197 6.58579 13.9987L4 16.5799V4H20V14.238Z", fill: "currentColor" })));
}
export default SvgImage;
